import { ToursEnum } from './../../../enums/tour/tours.enum';
import { LocalStorageEnum } from './../../../enums/utils/local-storage.enum';
import Step from 'shepherd.js/src/types/step';
import {TourSteps} from './interface/tour-steps.interface';

export const registerMealPlanNoFoodDishesStep: (tourSteps: TourSteps) => Step.StepOptions[] =
  ({steps, buttons, services, events, cb}: TourSteps): Step.StepOptions[] => {
    return [
      {
        ...steps.default,
        id: 'registerMealPlanStep1',
        title: 'Nombra tu plan de alimentación',
        text: `Escribe el nombre con el que será llamado tu plan, los buscadores usarán este valor para encontrarlo.`,
        attachTo: {
          element: '.input-name-meal-plan',
          on: 'bottom'
        },
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep2',
        title: 'Describe tu plan de alimentación',
        text: `Agrega una descripción de tu plan, esta descripción será vista por quienes utilicen tu plan de alimentación.`,
        attachTo: {
          element: '.input-description-meal-plan',
          on: 'bottom'
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep3',
        title: 'Cierra el panel lateral',
        text: `Haz clic para ocultar el panel, de esa forma podrás tener mejor visibilidad del plan alimenticio.`,
        attachTo: {
          element: '.icon-hide-menu',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.icon-hide-menu',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      /* HERE */
      {
        ...steps.default,
        id: 'registerMealPlanStep4',
        title: 'Barra de herramientas', // pendiente
        text: `Puedes consultar información respecto a los datos que vayas ingresando, además de realizar algunas acciones al plan alimenticio.`,
        attachTo: {
          element: '.toolbar',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep5',
        title: 'Estándares de planes de alimentación',
        text: `Puedes elegir entre dos formas de crear tu plan alimenticio: siguiendo el estándar SMAE o el estándar Internacional. Por defecto estará seleccionado el tipo SMAE.`,
        attachTo: {
          element: '.meal-plan-options',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Meta de calorías del plan alimenticio',
        text: `Aquí puedes ingresar la meta de calorías deseadas para el plan alimenticio. Para efectos del tour ingresamos una meta de 1900 kcal por defecto.`,
        attachTo: {
          element: '.input-meal-plan-goal',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
        beforeShowPromise: function () {
          events.events.emit('setCaloriesGoal');
          return new Promise(function (resolve): void {
            setTimeout(function () {
              resolve(true);
            }, 500);
          });
        },
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Estándar de distribución',
        text: `Se muestran los valores de macronutrientes elegidos por el experto, respecto al estándar seleccionado.`,
        attachTo: {
          element: '.distribution-standart',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [ {
          // tslint:disable-next-line:typedef
          action(): void {
            return this.next();
          },
          text: 'Siguiente'
        },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep6',
        title: 'Seguimiento de calorías',
        text: `Se muestra información sobre la meta de calorías deseada.`,
        attachTo: {
          element: '.meal-plan-calories',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Selecciona el estándar de distribución',
        text: `Puedes seleccionar entre los diferentes estándares de distribución de macronutrientes.`,
        attachTo: {
          element: '.select-strategy',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Meta de calorías',
        text: `Se muestra la meta deseada de calorías del plan alimenticio.`,
        attachTo: {
          element: '.total-calories',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: '',
        text: `Se muestra el nombre del macronutriente.`,
        attachTo: {
          element: '.macronutrient-name',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'Bloquear macronutriente',
        text: `Puedes bloquear máximo 2 macronutrientes para que sus valores no sean cambiados.`,
        attachTo: {
          element: '.block-macronutient-0 .ant-checkbox-input',
          on: 'top'
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'total',
        text: `Se muestra el total en gramos del macronutriente que tiene el plan alimenticio.`,
        attachTo: {
          element: '.block-macronutient-0 .tag-item:nth-child(1)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'total por periodo',
        text: `Se muestra el total en gramos del macronutriente que tiene el periodo seleccionado del plan alimenticio.`,
        attachTo: {
          element: '.block-macronutient-0 .tag-item:nth-child(2)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'Referencia',
        text: `Se muestra el porcentaje de referencia del estándar de distribución elegido.`,
        attachTo: {
          element: '.block-macronutient-0 .tag-item:nth-child(3)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'valor actual',
        text: `Se muestra el valor elegido por el experto para este macronutriente.`,
        attachTo: {
          element: '.block-macronutient-0 .tag-item:nth-child(4)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'Gramos',
        text: `Se muestra el total en gramos que se requiere para cumplir la meta de calorías.`,
        attachTo: {
          element: '.block-macronutient-0 .tag-item:nth-child(5)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Valor actual',
        text: `Se puede modificar el porcentaje deseado del macronutriente, deslizando la barra o ingresando directamente el valor en el campo numérico.`,
        attachTo: {
          element: '.slider-macronutrient-distribution-0',
          on: 'top'
        },
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Tabla macronutrimental',
        text: `Puedes establecer la cantidad deseada de cada categoría alimenticia. Además de ver su equivalente en porciones y la adecuación de SMAE.`,
        attachTo: {
          element: '.nutrient-table',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Categoría',
        text: `Nombre de la categoría.`,
        attachTo: {
          element: 'tr.category-0 td:nth-child(1)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Cantidad',
        text: `Puedes agregar la cantidad de ingredientes deseada pertenecientes a la categoría. Para efectos del tour ingresamos una cantidad de 4 verduras.`,
        attachTo: {
          element: 'tr.category-0  td:nth-child(2) .ant-input-number',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
        beforeShowPromise: () => {
          events.events.emit('setQuantityIngredient');
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('tr.category-0 td:nth-child(2)', { behavior: 'auto', block: 'start', inline: 'end' });
            resolve(true);
          });
        }
      },

      /*  that.events.emit('setCaloriesGoal');
           return new Promise(function (resolve) {
             setTimeout(function () {
               resolve(true);
             }, 500);
           }); */
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Cantidad de calorías',
        text: `Es el equivalente en calorías de la cantidad de ingredientes ingreseados.`,
        attachTo: {
          element: 'tr.category-0  td:nth-child(4)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('tr.category-0 td:nth-child(4)', { behavior: 'auto', block: 'start', inline: 'end' });
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Cantidad de proteínas',
        text: `Es el equivalente en gramos de proteínas de la cantidad de ingredientes ingreseados.`,
        attachTo: {
          element: 'tr.category-0  td:nth-child(6)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('tr.category-0 td:nth-child(6)', { behavior: 'auto', block: 'start', inline: 'end' });
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Cantidad de lípidos',
        text: `Es el equivalente en gramos de lípidos de la cantidad de ingredientes ingreseados.`,
        attachTo: {
          element: 'tr.category-0  td:nth-child(8)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('tr.category-0 td:nth-child(8)', { behavior: 'auto', block: 'start', inline: 'end' });
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Cantidad de carbohidratos',
        text: `Es el equivalente en gramos de carbohidratos de la cantidad de ingredientes ingreseados.`,
        attachTo: {
          element: 'tr.category-0 td:nth-child(10)',
          on: 'top'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('tr.category-0 td:nth-child(10)', { behavior: 'auto', block: 'start', inline: 'end' });
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: 'Construir plan de alimentación',
        text: `Una vez agregados los valores en la tabla macronutrimental puedes comenzar a crear tu plan alimenticio. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.button-build-plan',
          on: 'top'
        },
        advanceOn: {
          selector: '.button-build-plan',
          event: 'click'
        },
        buttons: [
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep6',
        title: 'Macronutrientes',
        text: `Se muestran los valores de macronutrientes del plan alimenticio actual.`,
        attachTo: {
          element: '.meal-plan-macronutrient',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep6',
        title: 'Micronutrientes',
        text: `Se muestran los valores de micronutrientes que contiene el plan alimenticio actual.`,
        attachTo: {
          element: '.meal-plan-micronutrient',
          on: 'bottom'
        },
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              return this.next();
            },
            text: 'Siguiente'
          },
          {...buttons.cancel}
        ],
      },
      /* HERE END */
      {
        ...steps.default,
        id: 'registerMealPlanStep4',
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        title: '¿Qué son los periodos?',
        text: `Un periodo es un conjunto de comidas o instrucciones, como por ejemplo, las comidas que tendrá el paciente durante un día.`,
        attachTo: {
          element: '.fit-content-tab-nav-operation',
          on: 'bottom'
        },
        canClickTarget: false,
        beforeShowPromise: () => {
          return new Promise((resolve): void => {
            services.utilitiesService.scrollToElement('.fit-content-tab-nav-operation', { behavior: 'auto', block: 'center', inline: 'center'});
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'registerMealPlanStep5',
        title: 'Añade tu primer tiempo de comida',
        text: `Puedes agregar uno o varios tiempos de comida. Da clic para continuar.`,
        attachTo: {
          element: '.add-time',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.add-time',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'registerMealPlanStep6',
        title: 'Nombra tu tiempo de comida',
        text: `Por ejemplo podrías llamarle "Desayuno". y colocar lo que el paciente debe comer durante este tiempo. Este campo es requerido, ingresalo y sal del campo para continuar.`,
        attachTo: {
          element: '.input-name-time-food',
          on: 'bottom'
        },
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep7',
        title: 'Horario recomendado',
        text: `Puedes agregar un horario recomendado, sin embargo, no es requerido. Para fines de este tour omitiremos este paso pero siempre puedes regresar y modificar todos los planes que hayas construido.`,
        attachTo: {
          element: '.hour',
          on: 'bottom'
        },
        canClickTarget: false,
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep8',
        title: '¡Ya casi acabamos el tour!',
        text: `Debes seleccionar un tipo de tiempo de comida, dependiendo del tipo seleccionado puedes agregar una receta o un conjunto de ingredientes, incluso una instrucción. Da clic para continuar.`,
        attachTo: {
          element: '.meal-plan-type-0',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.meal-plan-type-0',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'registerMealPlanStep9',
        title: 'Abre el buscador de recetas.',
        text: `Se mostrará una lista de todas las recetas que puedes utilizar. Da clic para continuar.`,
        attachTo: {
          element: '.select-meal-plan',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.select-meal-plan',
          event: 'click'
        },
        buttons: [{...buttons.cancel}],
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep10',
        title: 'Selecciona la receta',
        text: `¡Ups! vemos que no se han registrado recetas. No te preocupes, seguiremos el tour. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.ant-select-dropdown',
          on: 'bottom'
        },
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep11',
        title: 'Guarda tu primer tiempo de comida',
        text: `Si ya tienes todos los datos válidos puedes guardarlo. Da clic en el botón para continuar.`,
        attachTo: {
          element: '.btn-save-time-food',
          on: 'bottom'
        },
        advanceOn: {
          selector: '.btn-save-time-food',
          event: 'click'
        },
        canClickTarget: false,
        beforeShowPromise: async () => {
          return new Promise((resolve): void => {
            events.events.emit('closeFoodGroupSelectElement');
            resolve(true);
          });
        }
      },
      {
        ...steps.default,
        scrollTo: {
          inline: 'end',
          block: 'center',
          behavior: 'smooth',
        },
        id: 'registerMealPlanStep12',
        title: 'Guardar el plan de alimentación',
        text: 'Una vez que hayas ingresado los datos del plan de alimentación tendrás que dar clic en el botón para poder guardar los datos.',
        canClickTarget: false,
        attachTo: {
          element: '.btn-save-meal-plan',    // @ts-ignore

          on: 'bottom'
        },
        buttons: [
          {
            text: 'Entendido',
            // tslint:disable-next-line:typedef
            action(): void {
              cb('createMealPlan');
              if (services.storageService.getLocalItem(LocalStorageEnum.FORCE_TOUR_NAME) === ToursEnum.REGISTER_MEAL_PLAN) {
                // Si viene de la página de tours, le da la opción de mantenerse aquí o ir al listado de tours
                this.next();
              } else {
                // Si está haciendo el tour como usuario nuevo, completa este tour y comienza el tour de crear paciente
                this.complete();
              }
            },
          },
          {...buttons.cancel},
        ]
      },
      {
        ...steps.default,
        id: 'registerMealPlanStep13',
        title: 'Tour finalizado',
        text: '¡Muy bien!. Has finalizado el tour de "Registrar plan de alimentación".',
        canClickTarget: false,
        buttons: [
          {
            // tslint:disable-next-line:typedef
            action(): void {
              cb('goToTours');
            },
            text: 'Ir al listado de tours',
            classes: 'shepherd-button shepherd-button-secondary',
          },
          {
            // tslint:disable-next-line:typedef
            action(): void {
              cb('keepMeHere');
            },
            text: 'Mantenerme aquí'
          },
          {...buttons.cancel}
        ]
      }
    ];
  };
